export default __webpack_public_path__ + "static/media/logo-horizontal-y.a36de4a1.png";